import { I18n } from '@calendly/i18n'
import { ControlUI } from '@calendly/ui/components/select'
import { BodyText } from '@calendly/ui/components/typography'

import {
  GroupHeader,
  EventTypeCheckboxField,
  WideMarker,
  NotAvailable,
  MenuActionItem,
  Placeholder,
} from '../styles'


const EventTypeLabel = ({ item }) => {
  const notAvailable = item.deleted || item.active === false
  return (
    <>
      <WideMarker
        data-component="event-type-marker"
        isNotAvailable={notAvailable}
        color={item.color}
      />
      <BodyText color={notAvailable ? 'muted' : 'standard'} inline>
        {`${item.name} `}
        {notAvailable && (
          <NotAvailable>
            {
              item.deleted
                ? I18n.t('publisher.account_settings.meeting_intelligence.recording_rules.deleted')
                : I18n.t('publisher.account_settings.meeting_intelligence.recording_rules.inactive')
            }
          </NotAvailable>
        )}
      </BodyText>
    </>
  )
}


export const EventTypeSelectControl = ({ isExpanded, onClick, disabled, placeholder, count, total }) => (
  <ControlUI
    disabled={disabled}
    expanded={isExpanded}
    onClick={onClick}
    aria-expanded={isExpanded}
    aria-haspopup="dialog"
    aria-controls="event-type-select-popup"
  >
    {isExpanded && count === 0 && (
      <Placeholder>
        {I18n.t('publisher.meeting_intelligence.dropdown.select_event_types.placeholder')}
      </Placeholder>
    )}
    {!isExpanded && count === 0 && (
      <Placeholder>{placeholder}</Placeholder>
    )}
    {(count > 0 && count < total) && I18n.t(
      'publisher.meeting_intelligence.dropdown.select_event_types.count_selected',
      { count }
    )}
    {count === total && I18n.t('publisher.meeting_intelligence.dropdown.select_event_types.all_selected')}
  </ControlUI>
)

const Item = ({ className, item, onChange, value = false }) => {
  if (!item) return null
  return (
    <MenuActionItem className={className}>
      <EventTypeCheckboxField
        label={(
          <EventTypeLabel item={item}>
            {item.name}
          </EventTypeLabel>
        )}
        checked={value}
        onChange={onChange}
      />
    </MenuActionItem>
  )
}

const ItemList = ({ eventTypeId, items, onChange }) => items.map((item) => (
  <Item
    key={item.id}
    item={item}
    value={item.selected}
    onChange={(isChecked) => {
      onChange(eventTypeId, item.id, isChecked)
    }}
  />
))


export const AllEventsTypes = ({ eventTypeId, eventTypes, onChange, name }) => {
  if (!eventTypes || !eventTypes?.length) return null
  return (
    <>
      <GroupHeader>
        {name}
      </GroupHeader>
      <ItemList
        eventTypeId={eventTypeId}
        items={eventTypes}
        onChange={onChange}
      />
    </>
  )
}
